import * as React from 'react';
import { Divider, Grid } from '@material-ui/core';
import { withStyles, StyledComponentProps } from '@material-ui/core/styles';
import { styles } from '../../styles';
import moment from 'moment';
import { getMinutesOfDay } from './commonReservation-utilities';


interface IProps extends StyledComponentProps {
    minStartTime: Date;
    maxEndTime: Date;
    minuteHeight: number;
}

//OLD VERSION
// const rederHours = (props: IProps) => {
//     let hours: any[] = [];
//     let top = 100;
//     let time = moment(props.minStartTime);
//     let endOfTime = moment(props.maxEndTime);
//     hours.push(getTimeComponent(top, time, props.classes));
//     while (getMinutesOfDay(endOfTime) - getMinutesOfDay(time) > 0) {
//         if (top === 100 && !(time.get("minute") === 0 || time.get("minute") === 30)) {
//             //initial time minutes different from 30  o 00 
//             let initilaMinutes = time.get("minute");
//             let diffMinutes = (initilaMinutes > 30 ? 60 - initilaMinutes : 30 - initilaMinutes) % 60;
//             top += diffMinutes * props.minuteHeight;
//             time.add(diffMinutes, "minute");
//         } else {
//             let clonedTime = moment(time).add(15, "minute");
//             let diffEnd = getMinutesOfDay(endOfTime) - getMinutesOfDay(clonedTime);
//             if (diffEnd => 15) {
//                 top += 15 * props.minuteHeight;
//                 time.add(15, "minute");
//             } else {
//                 let lastTime = getMinutesOfDay(endOfTime) - getMinutesOfDay(time);
//                 top += lastTime * props.minuteHeight;
//                 time.add(lastTime, "minute");
//             }
//         }
//         hours.push(getTimeComponent(top, time, props.classes));
//     }
//     return hours;
// }

const initTop = 100;

const rederHours = (props: IProps) => {
    let hours: any[] = [];
    let top = initTop;
    let time = moment(props.minStartTime);
    console.warn("time", time.format("HH:mm"))
    let endOfTime = moment(props.maxEndTime);
    while (getMinutesOfDay(endOfTime) - getMinutesOfDay(time) > 15) {
        let clonedTime = moment(time).add(15, "minute");
        let diffEnd = getMinutesOfDay(endOfTime) - getMinutesOfDay(clonedTime);
        if (diffEnd >= 15) {
            if (top !== initTop) {
                time.add(15, "minute");
            }
            top += 15 * props.minuteHeight;
        } else {
            let lastTime = getMinutesOfDay(endOfTime) - getMinutesOfDay(time);
            top += lastTime * props.minuteHeight;
            time.add(lastTime, "minute");
        }
        hours.push(getTimeComponent(top, time, props.classes));
    }
    return hours;
}

const getTimeComponent = (top: number, time: moment.Moment, classes: any) => (
    <div className={classes.reservationHourContainer} style={{ top: top - 20 }}>
        <div style={{ height: "20px" }}>{time.format("HH")}:{time.format("mm")}</div>
        <Divider className={classes.reservationHourLine} />
    </div>
)


const ReservationHeader = (props: IProps) => {
    const classes = props.classes;
    return (
        <Grid container className={classes.reservationHourColumn}>
            {/* <Grid item xs={12} >
                TEMPO
          </Grid> */}
            {rederHours(props)}
        </Grid>
    );

};
export default withStyles(styles as any)(ReservationHeader)